// Updated TriggerForm.tsx
import { Stack } from '@mantine/core';
import { TriggerStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import TriggerFields from '@/pages/Editor/components/StepSidebar/StepForms/TriggerStep/TriggerFields.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';

type props = {
  step: TriggerStep;
};

export function TriggerForm({ step }: props) {
  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      <TriggerFields step={step} />
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
